import { render, staticRenderFns } from "./IBSList_old.vue?vue&type=template&id=120b1d7c"
import script from "./IBSList_old.vue?vue&type=script&lang=js"
export * from "./IBSList_old.vue?vue&type=script&lang=js"
import style0 from "./IBSList_old.vue?vue&type=style&index=0&id=120b1d7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports